var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-right"},[_c('div',{staticClass:"thumb-qr-text"},[_c('img',{attrs:{"src":require("@/assets/images/home-page/pc/qr_text.png")}})]),_c('div',{staticClass:"thumb-pr"},[_c('img',{attrs:{"src":require("@/assets/images/home-page/pc/qr_img.png")}})])])
}]

export { render, staticRenderFns }